import { Color, PosterHeight, PosterWidth, ScreenSize, Size } from '../enums';

const Theme = {
  Color,
  PosterHeight,
  PosterWidth,
  ScreenSize,
  Size,
};

export default Theme;
